import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FORMAT_IDR } from "../lib/constants";
import { imageUrl } from "../lib/api";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="card-product group flex flex-col"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0a0a0a]">
        {product.images?.length ? (
          <img
            src={imageUrl(product.images[0].url)}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover grayscale-[40%] opacity-90 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-[1.04] transition-all duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#666] text-xs">
            No Image
          </div>
        )}
        {product.badges?.length > 0 && (
          <div className="absolute top-3 left-3 flex flex-col gap-2">
            {product.badges?.map((b) => (
              <span
                key={b}
                className={`text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 ${
                  b === "BEST SELLER"
                    ? "bg-[#FF3B30] text-white"
                    : "bg-[#CCFF00] text-black"
                }`}
              >
                {b}
              </span>
            ))}
          </div>
        )}
        <div className="absolute top-3 right-3 w-9 h-9 bg-[#0a0a0a] border border-[#262626] inline-flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
      <div className="p-4 flex flex-col gap-1.5 flex-1">
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3]">
          {product.category_name}
        </p>
        <h3 className="font-display text-lg uppercase text-white tracking-tight leading-tight">
          {product.name}
        </h3>
        <p className="text-sm text-[#A3A3A3] line-clamp-2 mt-1">
          {product.short_description}
        </p>
        <div className="mt-3 flex items-baseline justify-between">
          <span className="text-xs uppercase tracking-widest text-[#A3A3A3]">
            Mulai
          </span>
          <span className="font-display text-xl text-[#CCFF00]">
            {FORMAT_IDR(product.price_from)}
          </span>
        </div>
      </div>
    </Link>
  );
}
